import React, { Fragment } from 'react';
import SubcategoryHeader from './SubcategoryHeader';
import CategoryBody from './CategoryBody';
import TettraEditor from '../../tettra-editor/components/TettraEditor';
import contentToEditorState from '../../tettra-editor/utilities/contentToEditorState';
import { sanitizeHTML } from '../../utilities/sanitizeHTML';

const READ_ONLY = true;

const EDITOR_CONFIG = {
    readOnly: READ_ONLY,
    enableSmallEditor: true,
    spellCheck: false,
    enableAutosave: false,
    enableTables: false,
    enableInsertControls: false,
    enableMentionSuggestions: true,
    enableInternalSuggestions: true,
    enableExternalSuggestions: false,
    enableFileUpload: false,
};

const SubcategoryDescription = ({ subcategory }) => {
    if (!subcategory.description_content_state) {
        const sanitizedHtml = sanitizeHTML(subcategory.description);
        return <div className="mt1 mb1" dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />;
    }

    const editorState = contentToEditorState(JSON.parse(subcategory.description_content_state), READ_ONLY);
    if (!editorState.getCurrentContent().getPlainText().trim()) {
        return null;
    }

    return (
        <TettraEditor
            config={EDITOR_CONFIG}
            editorState={editorState}
            updateModel={() => null}
            className="left"
        />
    );
};

const PageHeader = ({ subcategory }) => (
    <div className="page-header">
        <h1 className="page-title">
            {subcategory.name}
        </h1>
        <SubcategoryDescription subcategory={subcategory} />
    </div>
);

const SubcategoryShowContainer = ({ subcategory }) => (
    <Fragment>
        <SubcategoryHeader subcategory={subcategory} />
        <div className="p2 scrollable-column flex-auto sm-px3">
            <div className="container relative">
                <PageHeader subcategory={subcategory} />
                <CategoryBody subcategory={subcategory} folderItems={window.folderItems} />
            </div>
        </div>
    </Fragment>
);

export default SubcategoryShowContainer;
